import { FC } from 'react';
import cx from 'classnames/bind';

import styles from './Points.module.scss';

const cn = cx.bind(styles);

interface PointsProps {
  points: number;
}

const Points: FC<PointsProps> = ({ points }) => (
  <div className={cn('points-wrapper')}>
    <span className={cn('points')}>{points}</span>
  </div>
);
export default Points;
